import queryString from "query-string";
import _isEmpty from "lodash/isEmpty";
import { safeNavigation } from "../utils";
import Cookies from "js-cookie";
import { showNotification } from "../utils";
import { PythonService } from "./python";
import { resolveApiRoot } from "./apiUrl";

const handleServerErrors = async (response) => {
  try {
    if (!response.ok) {
      return response.json().then((data) => {
        throw new Error(data.message);
      });
    }
    if (response.status === 204) return null;
    if (response.status >= 200 && response.status < 300) {
      try {
        return await response.json();
      } catch (e) {
        return {};
      }
    }
    if (response.status === 401) {
      showNotification("¡Aviso!", "Acción no permitida", "warning");
      //setTimeout(() => {
      //Cookies.remove("token")
      //redirect("/")
      //}, 3000)
    }
    if (response.status === 403) {
      showNotification("Error", "El acceso ha sido prohibido", "error");
      //setTimeout(() => {
      //Cookies.remove("token")
      //redirect("/")
      //}, 3000)
    }
    if (response.status === 422) {
      showNotification(
        "¡Aviso!",
        "Verifica si la informacion esta completa",
        "warning"
      );
    }
    if (response.status >= 500) {
      showNotification(
        "Error",
        `Error del servidor ${JSON.stringify({}, null, 2)}`,
        "error"
      );
    }
    throw new Error("Server error occurred");
  } catch (error) {
    showNotification("Error", error.message, "warning");
  }
};

const request = async (method, endpoint, queryArray, body, api = "default") => {
  if (_isEmpty(endpoint)) return;
  const query = !_isEmpty(queryArray)
    ? typeof queryArray === "string"
      ? queryArray
      : `?${queryString.stringify(queryArray)}`
    : "";

  const API = {
    default: [process.env.REACT_APP_API_URL, "v1"],
  };

  const url = `${API[api][0]}/api/${API[api][1]}${endpoint}${query}`;

  const payload = body ? { body: JSON.stringify(body) } : {};

  const variables = safeNavigation(body, "query")
    ? {
        data: {
          query: safeNavigation(body, "query"),
          variables: safeNavigation(body, "variables"),
        },
      }
    : {};

  const fetchParams = {
    method: method,
    headers: {
      "content-type": "application/json",
      Authorization: "Bearer " + Cookies.get("token"),
    },
    ...payload,
    ...variables,
  };

  try {
    const response = await window
      .fetch(url, fetchParams)
      .then(handleServerErrors)
      .then((jsonRespose) => {
        if (process.env.REACT_APP_DEBUG) {
          console.log(`${method}: ${endpoint}${query}`, jsonRespose);
        }
        return jsonRespose;
      });
    return response;
  } catch (error) {
    throw error;
  }
};

// HTTP GET
const Get = (route, queryParams, body, api) => {
  return request("GET", route, queryParams, body, api);
};
// HTTP POST
const Post = (route, queryParams, body, api) => {
  return request("POST", route, queryParams, body, api);
};
// HTTP PUT
const Put = (route, queryParams, body, api) => {
  return request("PUT", route, queryParams, body, api);
};
// HTTP DELETE
const Delete = (route, queryParams, body, api) => {
  return request("DELETE", route, queryParams, body, api);
};

const API_BASE = process.env.REACT_APP_API_URL;

const requestWithStatus = async (method, url, body) => {
  const response = await fetch(url, {
    method,
    headers: {
      "content-type": "application/json",
      Authorization: "Bearer " + Cookies.get("token"),
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  if (response.ok) {
    if (response.status === 204) return { ok: true, status: response.status };
    try {
      const data = await response.json();
      return { ok: true, status: response.status, data };
    } catch {
      return { ok: true, status: response.status };
    }
  }

  let message = `Error del servidor (${response.status})`;
  try {
    const data = await response.json();
    message = data.message || message;
  } catch {
    // keep default message
  }

  return { ok: false, status: response.status, message };
};

export class User {
  static GetById(data) {
    return Post("/user", {}, data);
  }

  static Create(data) {
    return Post("/auth/signup", {}, data);
  }

  static Update(data) {
    return Put("/users/general", {}, data);
  }

  static UpdateProperties(data) {
    return Put("/users/properties", {}, data);
  }

  static UpdatePassword(data) {
    return Put("/users/password", {}, data);
  }

  static UpdateCustomerId(data) {
    return requestWithStatus(
      "PUT",
      `${API_BASE}/api/v1/users/customer-id`,
      data
    );
  }
}

export class Student {
  static Update(data) {
    return Put("/student", {}, data);
  }
}

export class Pace {
  static Register(data) {
    return Post("/pace/student", {}, data);
  }

  static Clear(studentId) {
    return Delete(`/clear/${studentId}`);
  }

  static GetLevelsByLanguage(language) {
    return Get(`/levels/${language}`);
  }

  static GetFilters(language) {
    return Get(`/pace/filters/${language}`);
  }
}

export class Notification {
  static Create(data) {
    return Post("/notifications/bulk", {}, data);
  }

  static GetMessages(queryParams) {
    return Get("/notifications", queryParams);
  }

  static GetUserMessages(queryParams) {
    return Get("/notifications/user", queryParams);
  }

  static GetLatest(limit = 10) {
    return Get("/notifications/latest", { limit });
  }

  static Delete(ids) {
    return Delete("/notifications", {}, { ids });
  }
}

export class Teacher {
  static GetByFilters(queryParams) {
    return Get("/teachers", queryParams);
  }
}

export class Zoom {
  static GetByFilters(queryParams) {
    return Get("/zoom", queryParams);
  }
}

export class Location {
  static GetByFilters(queryParams) {
    return Get("/location", queryParams);
  }
}

export class Book {
  static GetByFilters(queryParams) {
    return Get("/books", queryParams);
  }
}

export class Class {
  static Create(body) {
    return Post("/class", {}, body);
  }

  static GetById(id) {
    return Get(`/class/${id}`);
  }

  static GetByFilters(queryParams) {
    return Get("/class", queryParams);
  }

  static GetAssistance(id) {
    return Get(`/class/${id}/assistance`);
  }

  static UpdateApproach(id, body) {
    return requestWithStatus(
      "PUT",
      `${API_BASE}/api/v1/class/${id}/approach`,
      body
    );
  }

  static UpdateAssistance(id, body) {
    return requestWithStatus(
      "PUT",
      `${API_BASE}/api/v1/class/${id}/assistance`,
      body
    );
  }

  static GetSession(id) {
    return Get(`/class/${id}/session`);
  }

  static ChangeStudent(data) {
    return Put("/change-class", {}, data);
  }

  static Register(id) {
    return Put(`/class/${id}/registration`);
  }
}

// RFC-4: status-returning helpers used only by the "Modificar clase" screen
// (src/components/EditarClase). They never call showNotification and never go
// through handleServerErrors, so the caller maps every HTTP status to Spanish copy.
// A network failure (fetch rejects) is returned as status 0 so the caller can map it.
const classEditRequest = async (method, path, body) => {
  try {
    return await requestWithStatus(method, `${API_BASE}/api/v1${path}`, body);
  } catch {
    return { ok: false, status: 0, message: "" };
  }
};

export class ClassEdit {
  static GetDetail(id) {
    return classEditRequest("GET", `/class/${id}`);
  }

  static GetAssistance(id) {
    return classEditRequest("GET", `/class/${id}/assistance`);
  }

  static GetBooks(language) {
    return classEditRequest(
      "GET",
      `/books?language=${encodeURIComponent(language || "")}`
    );
  }

  static GetLocations() {
    return classEditRequest("GET", "/location");
  }

  // startDate must be the raw "YYYY-MM-DDTHH:mm:ss" string from GET /class/{id}.
  static GetZoomKeys(startDate) {
    return classEditRequest(
      "GET",
      `/zoom?start_date=${encodeURIComponent(startDate || "")}`
    );
  }

  static Update(id, body) {
    return classEditRequest("PATCH", `/class/${id}`, body);
  }

  static RemoveStudent(classId, studentId) {
    return classEditRequest(
      "DELETE",
      `/class/${classId}/students/${encodeURIComponent(studentId)}`
    );
  }
}

export class Code {
  static CheckProgram(studentId) {
    return Get(`/${studentId}/code-program`);
  }

  static SubmitCode(studentId, body) {
    return Put(`/${studentId}/code`, {}, body);
  }
}

const COUNTER_RESPONSE_KEYS = [
  "regularDaily",
  "workshopDaily",
  "regularWeekly",
  "regularAltWeekly",
  "workshopWeekly",
  "regularMonthly",
  "regularAltMonthly",
];

const parseCountersPayload = (raw) => {
  if (!raw || !raw.trim()) return null;

  try {
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === "object") {
      return parsed;
    }
  } catch {
    // Spring puede truncar el JSON por referencia circular Counters ↔ User.
  }

  const data = {};
  let found = 0;

  for (const key of COUNTER_RESPONSE_KEYS) {
    const match = raw.match(new RegExp(`"${key}"\\s*:\\s*(-?\\d+)`));
    if (match) {
      data[key] = parseInt(match[1], 10);
      found += 1;
    }
  }

  return found > 0 ? data : null;
};

const subtypeRequest = async (method, path, body) => {
  const response = await fetch(`${resolveApiRoot()}/api/v1${path}`, {
    method,
    headers: {
      "content-type": "application/json",
      Authorization: "Bearer " + Cookies.get("token"),
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  if (response.ok) {
    if (response.status === 204) return { ok: true, status: response.status, data: null };
    try {
      const data = await response.json();
      return { ok: true, status: response.status, data };
    } catch {
      return { ok: true, status: response.status, data: null };
    }
  }

  let message = `Error del servidor (${response.status})`;
  try {
    const data = await response.json();
    message = data.message || message;
  } catch {
    // keep default
  }

  return { ok: false, status: response.status, message };
};

export class Subtype {
  static List() {
    return subtypeRequest("GET", "/subtypes");
  }

  static Create(body) {
    return subtypeRequest("POST", "/subtypes", body);
  }

  static Update(id, body) {
    return subtypeRequest("PUT", `/subtypes/${id}`, body);
  }

  static Remove(id) {
    return subtypeRequest("DELETE", `/subtypes/${id}`);
  }
}

export class Contact {
  static GetAll() {
    return Get("/contact");
  }

  static Update(id, data) {
    return Put(`/contact/${id}`, {}, data);
  }
}

export class Counters {
  static async GetByCustomerId(customerId) {
    const url = `${API_BASE}/api/v1/counters/${customerId}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "content-type": "application/json",
        Authorization: "Bearer " + Cookies.get("token"),
      },
    });

    if (response.status === 404) {
      return { ok: false, status: 404 };
    }

    const raw = await response.text();

    if (!response.ok) {
      let message = `Error del servidor (${response.status})`;
      try {
        const data = JSON.parse(raw);
        message = data.message || message;
      } catch {
        // keep default
      }
      throw new Error(message);
    }

    const data = parseCountersPayload(raw);
    if (data) {
      return { ok: true, data };
    }

    // Existe fila (200) pero el body no es JSON válido por serialización circular en backend.
    return { ok: true, existingButUnreadable: true };
  }

  static async Update(customerId, body) {
    const url = `${API_BASE}/api/v1/counters/${customerId}`;
    const response = await fetch(url, {
      method: "PUT",
      headers: {
        "content-type": "application/json",
        Authorization: "Bearer " + Cookies.get("token"),
      },
      body: JSON.stringify(body),
    });

    if (response.ok) {
      return { ok: true, status: response.status };
    }

    let message = `Error del servidor (${response.status})`;
    try {
      const data = await response.json();
      message =
        data.message ||
        (Array.isArray(data.errors) ? data.errors.join(", ") : null) ||
        message;
    } catch {
      // keep default
    }

    return { ok: false, status: response.status, message };
  }
}

export { PythonService };

const Api = {
  User,
  Pace,
  Notification,
  Teacher,
  Zoom,
  Location,
  Book,
  Class,
  ClassEdit,
  Student,
  Code,
  Counters,
  Contact,
  Subtype,
  PythonService,
};

export default Api;
